/* VidMax Bets, from brain/vidmax/plan/bets.md bundled at build time (each deploy picks up edits).
   The cross-company Mission widget lives in missionWidget.tsx and reuses betDetails/staticState. */
import betsMarkdown from "../../../../../../brain/vidmax/plan/bets.md?raw"

import { parseBets, rankedBets } from "../betsModel"
import type { IBet } from "../betsModel"
import { EVerdict } from "../homeDashboard.types"
import type { IWidgetDefinition, IWidgetResult, IWidgetState } from "../homeDashboard.types"
import { ExternalLink, KeyValues, REPO_BLOB } from "./WidgetParts"

const BETS_URL = `${REPO_BLOB}/brain/vidmax/plan/bets.md`
const DECISIONS_URL = `${REPO_BLOB}/brain/vidmax/plan/decisions.md`
const RANKED_SHOWN = 10
const SUMMARY = parseBets(betsMarkdown)

const BET_DETAIL_FIELDS = [
  "Why",
  "Hypothesis",
  "Build",
  "Internal done",
  "External proof",
  "Evidence",
  "Work type",
  "Week",
  "When",
  "Not In Scope",
]

export const betDetails = (bet: IBet) => (
  <KeyValues pairs={BET_DETAIL_FIELDS.map((field) => [field, bet.fields[field]])} />
)

export const staticState = (result: IWidgetResult): IWidgetState => ({
  result,
  isLoading: false,
  isFetching: false,
  refetch: () => undefined,
})

const BETS_RESULT: IWidgetResult = (() => {
  const ranked = rankedBets(SUMMARY)
  return {
    verdict: EVerdict.UNKNOWN,
    count: `${ranked.length} ranked`,
    rows: ranked.map((bet, i) => ({
      key: bet.id,
      verdict: EVerdict.UNKNOWN,
      pill: { text: bet.rank ? `#${bet.rank}` : bet.id, verdict: EVerdict.UNKNOWN },
      title: `${bet.id} · ${bet.title}`,
      sub: [bet.fields.Impact, bet.section].filter(Boolean).join(" · "),
      meta: bet.fields["Work type"],
      details: betDetails(bet),
      href: BETS_URL,
      hrefLabel: "Open bets.md",
      quiet: i >= RANKED_SHOWN,
    })),
    ordered: true,
    quietLabel: `${Math.max(0, ranked.length - RANKED_SHOWN)} more bets`,
    empty: "No ranked bets.",
    lead: (
      <div className="hd-links">
        <ExternalLink href={BETS_URL}>bets.md</ExternalLink>
        <ExternalLink href={DECISIONS_URL}>Decisions</ExternalLink>
        <ExternalLink href={`${REPO_BLOB}/brain/vidmax/plan/learnings.md`}>Learnings</ExternalLink>
      </div>
    ),
  }
})()

export const betsWidget: IWidgetDefinition = {
  id: "bets",
  title: "VidMax bets",
  description: "Ranked VidMax candidates and experiments",
  columns: { 2: 1, 3: 1, 4: 1, 5: 2, 6: 2 },
  link: { href: BETS_URL, label: "Open bets.md" },
  companies: ["vidmax"],
  useWidget: () => staticState(BETS_RESULT),
}
